import z from 'zod'
import {
  firestoreWriteTimestamp,
  nullSafeOptionalFirestoreTimestamp,
  nullSafeOptionalString,
} from '../shared/schema'

export enum UserProfileNotificationType {
  Custom = 0,
  GroupChat = 1,
  GradeAppeal = 2,
}

export const gradeAppealNotificationOutcomeSchema = z.enum([
  'accepted',
  'partially-accepted',
  'declined',
])

export const gradeAppealNotificationEventSchema = z.union([
  z.literal('submitted'),
  gradeAppealNotificationOutcomeSchema,
])

export type GradeAppealNotificationEvent = z.infer<
  typeof gradeAppealNotificationEventSchema
>

export const gradeAppealNotificationContextSchema = z.object({
  gradeAppealId: z.string(),
  sectionId: z.string(),
  assignmentId: z.string(),
  roomId: z.string(),
  slideDeckId: z.string(),
  event: gradeAppealNotificationEventSchema,
  finalScore: z.string().optional(),
})

export const schema = z.object({
  notificationContextKey: z.record(z.string()),
  notificationSourceUserId: z.string(),
  notificationSubject: z.string(),
  notificationHTMLBody: nullSafeOptionalString(),
  notificationTextBody: nullSafeOptionalString(),
  notificationSent: z.boolean(),
  notificationSeen: z.boolean(),
  notificationType: z.preprocess(
    (val) => val ?? UserProfileNotificationType.Custom,
    z.nativeEnum(UserProfileNotificationType)
  ),
  createdAt: nullSafeOptionalFirestoreTimestamp(),
  updatedAt: nullSafeOptionalFirestoreTimestamp(),
})

export const gradeAppealNotificationWriteSchema = schema.extend({
  notificationContextKey: gradeAppealNotificationContextSchema,
  notificationType: z.literal(UserProfileNotificationType.GradeAppeal),
  createdAt: firestoreWriteTimestamp,
  updatedAt: firestoreWriteTimestamp,
})

export const empty = Object.freeze(
  schema.parse({
    notificationContextKey: {},
    notificationSourceUserId: '',
    notificationSubject: '',
    notificationSent: false,
    notificationSeen: false,
    notificationType: UserProfileNotificationType.Custom,
    createdAt: { seconds: 0, nanoseconds: 0 },
    updatedAt: { seconds: 0, nanoseconds: 0 },
  })
)

export interface FirestoreUserProfileNotification extends z.infer<
  typeof schema
> {}
